import React from 'react';

import { FormulaDetailModel } from '../../../../../models/formula.model';

import { SummaryItem } from './SummaryItem';

export const TriggerSummary = ({
    formula,
}: {
    formula: FormulaDetailModel;
}) => {
    return (
        <SummaryItem
            label="Trigger"
            value={formula.compound_trigger?.name ?? '-'}
        />
    );
};
